export default [
  {
    id: 'c84f2e12-31aa-4979-bdc1-b60eb5998370',
    name: 'safety-evaluation',
    path: '/safety-evaluation',
    meta: { title: '安全评价' },
    children: [
      {
        id: '7c4bee4b-ac54-40b9-9f8e-13416a648887',
        name: 'safety-evaluation-list',
        path: 'list',
        component(resolve) {
          require(['./views/EvaluationThinkTank.vue'], resolve)
        },
        meta: {
          title: '安全评价智库',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            batchImport: {
              id: 3,
              name: 'batchImport',
              desc: '导人',
              access: true,
            },
            batchExport: {
              id: 4,
              name: 'batchExport',
              desc: '导出',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: '3ab651b5-f140-417d-bd8e-27f1ae49b016',
        name: 'safety-evaluation-info',
        path: 'info',
        component(resolve) {
          require(['./components/EvaluationThinkTankForm.vue'], resolve)
        },
        meta: {
          title: '安全评价智库',
          hidden: true,
          tabnab: false,
          activeMenu: '/safety-evaluation/list',
        },
      },
      {
        id: '70ad9023-e14b-4617-b15e-d3984d2e0235',
        name: 'project-config',
        path: 'project-config',
        component(resolve) {
          require(['./views/ProjectConfig.vue'], resolve)
        },
        meta: {
          title: '评价项目配置',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            relation: {
              id: 1,
              name: 'relation',
              desc: '关联模块',
              access: true,
            },
            remove: {
              id: 2,
              name: 'remove',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '7921ffc9-a8d3-40a3-9b61-cfe9c875d8ab',
        path: 'stakeholder-evaluation-list',
        name: 'stakeholderEvaluationList',
        component: () => {
          return import('./views/EvaluationList')
        },
        meta: {
          title: '相关方自评',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            evaluate: {
              id: 3,
              name: 'evaluate',
              desc: '自评',
              access: true,
            },
            export: {
              id: 4,
              name: 'export',
              desc: '导出',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '查看',
              access: true,
              group: 'read',
            },
          },
        },
      },
      {
        id: '24651c91-f0e6-47a9-92d8-5f51c6442b86',
        path: 'unit-evaluation-list',
        name: 'unitEvaluationList',
        component: () => {
          return import('./views/EvaluationList')
        },
        meta: {
          title: '建设单位自评',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            evaluate: {
              id: 3,
              name: 'evaluate',
              desc: '自评',
              access: true,
            },
            export: {
              id: 4,
              name: 'export',
              desc: '导出',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '查看',
              access: true,
              group: 'read',
            },
          },
        },
      },
      {
        id: 'd6cb8f05-ddc0-4c67-bf0f-709d5fdb76f1',
        path: 'expert-evaluation-list',
        name: 'expertEvaluationList',
        component: () => {
          return import('./views/EvaluationList')
        },
        meta: {
          title: '外部专家评价',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            evaluate: {
              id: 3,
              name: 'evaluate',
              desc: '自评',
              access: true,
            },
            export: {
              id: 4,
              name: 'export',
              desc: '导出',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '查看',
              access: true,
              group: 'read',
            },
          },
        },
      },
    ],
  },
]
